angular.module('vehicle-booking', ['core', 'vehicle'])
    .constant('VehicleBookingConst', {
        eventUpdate: 'vehicle-booking.updated',
        tpl: 'app/vehicle-booking/'
    })
    .factory('VehicleBooking', function ($resource) {
        return $resource('crm/api/vehicle-booking/:id', {id: '@id'}, {
            table: {method: 'GET', url: 'crm/api/vehicle-booking/table', isArray: false},
            tableStatistics: {method: 'GET', url: 'crm/api/vehicle-booking/table-statistics', isArray: false},
            book: {method: 'POST', url: 'crm/api/vehicle-booking', isArray: false},
            update: {method: 'PUT'},
            availability: {method: 'GET', url: 'crm/api/vehicle-availability', isArray: false},
            dashboard: {method: 'GET', url: 'crm/api/vehicle-booking/dashboard', isArray: false},
            accept: {method: 'POST', url: 'crm/api/vehicle-booking/:id/accept', isArray: false},
            reject: {method: 'POST', url: 'crm/api/vehicle-booking/:id/reject', isArray: false},
            handoverKeys: {method: 'POST', url: 'crm/api/vehicle-booking/:id/handover', isArray: false},
            handoverKeysCancel: {method: 'POST', url: 'crm/api/vehicle-booking-reception-desk/history/:id/key-handover/cancel', isArray: false},
            returnKeys: {method: 'POST', url: 'crm/api/vehicle-booking/:id/return', isArray: false},
            returnKeysCancel: {method: 'POST', url: 'crm/api/vehicle-booking-reception-desk/history/:id/key-return/cancel', isArray: false},
            cancel: {method: 'POST', url: 'crm/api/vehicle-booking/:id/cancel', isArray: false},
            issues: {method: 'GET', url: 'crm/api/vehicle-booking/:id/issue', isArray: true},
        })
    })
    .factory('VehicleSniper', function ($resource) {
        return $resource('crm/api/vehicle-sniper/:id', {id: '@id'}, {
            dashboard: {method: 'GET', url: 'crm/api/vehicle-sniper/dashboard', isArray: true},
            disable: {method: 'PUT', url: 'crm/api/vehicle-sniper/:id/disable', isArray: false},
        })
    })
    .service('VehicleBookingService', function (modals, toastr, $rootScope, VehicleBooking, VehicleBookingConst) {
        this.add = params => {
            let entity = {
                id: null
            }
            angular.extend(entity, params)
            return this.edit(entity)
        }
        this.getDuration = function (startTime, nextBookingStartTime) {
            if (nextBookingStartTime === null)
                return null
            if (startTime == null)
                startTime = moment()
            return moment.preciseDiff(startTime, nextBookingStartTime) || "0 min"
        }
        this.sniper = filters => {
            modals.open(VehicleBookingConst.tpl + 'sniper-set.html', 'VehicleBookingSniperSetController', angular.copy(filters), {size: 'md'}, "$ctrl")
        }
        this.book = (vehicle, startTime, endTime) => {
            let entity = {
                vehicle: vehicle,
                startTime: startTime != null ? new Date(startTime) : null,
                endTime: endTime != null ? new Date(endTime) : null,
            }
            modals.open(VehicleBookingConst.tpl + 'book-modal.html', 'VehicleBookingBookController', angular.copy(entity), {size: 'lg'}, "$ctrl")
        }
        this.accept = entity => {
            let content = "Czy chcesz <b>ZAAKCEPTOWAĆ</b> rezerwację?";
            modals.confirm(content, () => VehicleBooking.accept({id: entity.id}).$promise.then(() => $rootScope.$broadcast(VehicleBookingConst.eventUpdate)));
        }
        this.reject = entity => {
            modals.open(VehicleBookingConst.tpl + 'reject-modal.html', 'VehicleBookingRejectController', angular.copy(entity), {size: 'sm'}, "$ctrl")
        }
        this.handoverKeys = entity => {
            modals.open(VehicleBookingConst.tpl + 'key-handover-modal.html', 'VehicleBookingKeyHandoverController', angular.copy(entity), {size: 'sm'}, "$ctrl")
        }
        this.returnKeys = entity => {
            modals.open(VehicleBookingConst.tpl + 'key-return-modal.html', 'VehicleBookingKeyReturnController', angular.copy(entity), {size: 'sm'}, "$ctrl")
        }
        this.cancel = entity => {
            modals.open(VehicleBookingConst.tpl + 'cancel-modal.html', 'VehicleBookingCancelController', angular.copy(entity), {size: 'sm'}, "$ctrl")
        }
        this.delete = entity => {
            return modals.confirmDelete("wybrany rekord", () => VehicleBooking.delete({id: entity.id}).$promise.then(() => $rootScope.$broadcast(VehicleBookingConst.eventUpdate)));
        }
    })
    .controller('VehicleBookingKeyHandoverController', function ($state, toastr, $scope, $rootScope, $uibModalInstance, VehicleBookingConst, data, VehicleBooking, VehicleBookingService) {
        this.VehicleBookingService = VehicleBookingService
        this.$onInit = () => {
            this.item = data
            this.currentTime = new Date()
        }
        this.cancel = () => $uibModalInstance.dismiss()
        this.save = () => {
            return VehicleBooking.handoverKeys({id: this.item.id}).$promise.then(result => {
                toastr.success('Zapisano')
                $uibModalInstance.close()
                $rootScope.$broadcast(VehicleBookingConst.eventUpdate)
            })
        }
        this.isDelayed = (time) => {
            return moment(this.currentTime).isAfter(time)
        }
    })
    .controller('VehicleBookingKeyReturnController', function ($state, toastr, $scope, $rootScope, $uibModalInstance, VehicleBookingConst, data, VehicleBooking, VehicleBookingService) {
        this.VehicleBookingService = VehicleBookingService
        this.$onInit = () => {
            this.item = data
            this.currentTime = new Date()
        }
        this.cancel = () => $uibModalInstance.dismiss()
        this.save = () => {
            return VehicleBooking.returnKeys({id: this.item.id}).$promise.then(result => {
                toastr.success('Zapisano')
                $uibModalInstance.close()
                $rootScope.$broadcast(VehicleBookingConst.eventUpdate)
            })
        }
        this.isDelayed = (time) => {
            return moment(this.currentTime).isAfter(time)
        }
    })
    .controller('VehicleBookingRejectController', function ($state, toastr, $scope, $rootScope, $uibModalInstance, VehicleBookingConst, data, VehicleBooking) {
        this.$onInit = () => {
            this.item = {
                comment: null,
                id: data.id
            }
        }
        this.cancel = () => $uibModalInstance.dismiss()
        this.save = () => {
            return VehicleBooking.reject(this.item).$promise.then(result => {
                toastr.success('Zapisano')
                $uibModalInstance.close()
                $rootScope.$broadcast(VehicleBookingConst.eventUpdate)
            })
        }
    })
    .controller('VehicleBookingCancelController', function ($state, toastr, $scope, $rootScope, $uibModalInstance, VehicleBookingConst, data, VehicleBooking) {
        this.$onInit = () => {
            this.item = {
                comment: null,
                id: data.id
            }
        }
        this.cancel = () => $uibModalInstance.dismiss()
        this.save = () => {
            return VehicleBooking.cancel(this.item).$promise.then(result => {
                toastr.success('Zapisano')
                $uibModalInstance.close()
                $rootScope.$broadcast(VehicleBookingConst.eventUpdate)
            })
        }
    })
    .controller('VehicleBookingBookController', function ($state, toastr, $scope, $rootScope, $uibModalInstance, VehicleBookingConst, data, VehicleBookingService, VehicleBooking, VehicleIssue, VehicleService, Principal) {
        this.VehicleBookingService = VehicleBookingService
        this.VehicleService = VehicleService
        this.$onInit = () => {
            this.item = data
            this.canReadVehicles = Principal.hasAnyAuthority(['ROLE_VEHICLE'])
            this.issues = []
            if (this.canReadVehicles)
                VehicleIssue.query({id: this.item.vehicle.id}).$promise.then(result => this.issues = result)
        }
        this.pickUser = () => {
            this.item.user = null
        }
        this.cancel = () => $uibModalInstance.dismiss()
        this.save = () => {
            VehicleBooking.book(this.item).$promise.then(result => {
                toastr.success('Rezerwacja została zapisana')
                $uibModalInstance.close()
                $state.go('vehicleBookingShow', {id: result.id})
                // $rootScope.$broadcast(VehicleBookingConst.eventUpdate)
            })
        }
    })
    .controller('VehicleBookingSniperSetController', function ($state, toastr, $scope, $rootScope, $uibModalInstance, VehicleBookingConst, data, VehicleService, VehicleBookingService, VehicleSniper) {
        this.VehicleBookingService = VehicleBookingService
        this.VehicleService = VehicleService
        this.$onInit = () => {
            this.item = {
                type: 'STRICT_TIME',
                filter: data
            }
        }
        this.cancel = () => $uibModalInstance.dismiss()
        this.save = () => {
            VehicleSniper.save(this.item).$promise.then(result => {
                toastr.success('Snajper ustawiony!')
                $uibModalInstance.close()
                $rootScope.$broadcast(VehicleBookingConst.eventUpdate)
            })
        }
        this.pickUser = () => {
            this.item.user = null
        }
    })
    .component('vehicleBookingList', {
        bindings: {
            page: '<',
            filters: '<',
            statistics: '<'
        },
        templateUrl: 'app/vehicle-booking/list.html',
        controller: function ($scope, $state, $stateParams, VehicleBookingService, VehicleBookingConst, VehicleService, Principal) {
            this.VehicleBookingService = VehicleBookingService
            this.VehicleService = VehicleService
            this.canReadVehicles = Principal.hasAnyAuthority(['ROLE_VEHICLE'])
            this.reset = () => this.filters = {}
            $scope.$on(VehicleBookingConst.eventUpdate, () => $state.reload())
            $scope.$on("file.saved", () => $state.reload())
        }
    })
    .component('vehicleBookingShow', {
        bindings: {
            item: '<',
        },
        templateUrl: 'app/vehicle-booking/show.html',
        controller: function ($scope, $state, $stateParams, VehicleBookingService, VehicleBookingConst, VehicleService, VehicleIssue, VehicleConst, VehicleBooking, VehicleIssueService, Principal) {
            this.VehicleBookingService = VehicleBookingService
            this.VehicleService = VehicleService
            this.VehicleIssueService = VehicleIssueService
            this.canReadVehicles = Principal.hasAnyAuthority(['ROLE_VEHICLE'])

            $scope.$on(VehicleBookingConst.eventUpdate, () => $state.reload())
            $scope.$on(VehicleConst.eventUpdate, () => $state.reload())
            $scope.$on("file.saved", () => $state.reload())
        }
    })
    .component('vehicleBookingDashboard', {
        templateUrl: 'app/vehicle-booking/dashboard.html',
        controller: function ($scope, $state, $stateParams, VehicleBookingService, VehicleBookingConst, VehicleService, VehicleConst, VehicleBooking, VehicleSniper, Vehicle, Principal) {
            this.VehicleBookingService = VehicleBookingService
            this.VehicleService = VehicleService
            this.$onInit = () => {
                this.filters = angular.copy($stateParams)
                this.canReadVehicles = Principal.hasAnyAuthority(['ROLE_VEHICLE'])
                this.services = {}
                if (this.canReadVehicles)
                    Vehicle.dashboard(angular.copy($stateParams)).$promise.then(result => this.services = result)
                VehicleBooking.dashboard(angular.copy($stateParams)).$promise.then(result => this.dashboard = result)
                VehicleSniper.dashboard().$promise.then(result => this.snipers = result)
                VehicleBooking.availability(angular.copy($stateParams)).$promise.then(result => this.availability = result)
            }
            this.reset = () => this.filters = {}
            $scope.$on(VehicleBookingConst.eventUpdate, () => this.$onInit())
            $scope.$on(VehicleConst.eventUpdate, () => this.$onInit())
            $scope.$on("file.saved", () => this.$onInit())
        }
    })
    .component('vehicleBookingAvailability', {
        bindings: {
            page: '<',
            filters: '<'
        },
        templateUrl: 'app/vehicle-booking/availability.html',
        controller: function ($scope, $state, $stateParams, VehicleBookingService, VehicleBookingConst, VehicleService, Principal) {
            this.VehicleBookingService = VehicleBookingService
            this.VehicleService = VehicleService
            this.canReadVehicles = Principal.hasAnyAuthority(['ROLE_VEHICLE'])
            this.reset = () => this.filters = {}
            this.$onInit = () => {
                this.filtersCopy = angular.copy(this.filters)
            }
            this.setEndTime = hours => {
                let start = this.filters.startTime == null ? moment() : moment(this.filters.startTime)
                this.filters.endTime = start.add(hours, 'h')
            }
            $scope.$on(VehicleBookingConst.eventUpdate, () => $state.reload())
            $scope.$on("file.saved", () => $state.reload())
        }
    })
    .component('vehicleBookingStatusLabel', {
        bindings: {
            status: '<'
        },
        template: `
                <span class="label label-default vehicle-booking-status-label {{$ctrl.status}}">{{ 'vehicle-booking.status.' + $ctrl.status | translate }}</span>
            `
    })
    .component('vehicleBookingTableWidget', {
        bindings: {
            titleKey: '@',
            items: '<',
            bookingRealization: '<',
        },
        templateUrl: 'app/vehicle-booking/_table-widget.html',
        controller: function (VehicleBookingService, VehicleService, Principal) {
            this.VehicleBookingService = VehicleBookingService
            this.VehicleService = VehicleService
            this.canReadVehicles = Principal.hasAnyAuthority(['ROLE_VEHICLE'])
        }
    })
    .component('vehicleSniperWidget', {
        bindings: {
            items: '<'
        },
        templateUrl: 'app/vehicle-booking/sniper-widget.html',
        controller: function ($state, VehicleBookingService, VehicleService, VehicleSniper, modals) {
            this.VehicleBookingService = VehicleBookingService
            this.VehicleService = VehicleService
            this.$onInit = () => {
                this.more = false
            }
            this.toggleMore = () => {
                this.more = !this.more
            }
            this.close = (item) => {
                let content = "Czy chcesz <b>WYŁĄCZYĆ</b> snajpera?";
                modals.confirm(content, () => VehicleSniper.disable({id: item.id}).$promise.then(() => $state.reload()));
            }
            this.open = (item) => {
                let filters = angular.copy(item.filter)
                filters.vehicle = item.filter.vehicle?.id
                filters.location = item.filter.location?.id
                $state.go('vehicleBookingAvailability', filters)
            }
        }
    })
    .component('vehicleBookingBtnOptions', {
        bindings: {
            item: '=',
            largeButton: '='
        },
        templateUrl: 'app/vehicle-booking/_btn-options.html',
        controller: function (VehicleBookingService, FilesLibrary, FilesSimpleUploadService) {
            this.VehicleBookingService = VehicleBookingService
            this.FilesLibrary = FilesLibrary
            this.FilesSimpleUploadService = FilesSimpleUploadService
        }
    })
    .run(function (NavbarLeftMenu) {
        NavbarLeftMenu.add({
            authorities: 'ROLE_VEHICLE_BOOKING',
            path: '/vehicle-booking-list',
            ico: 'fa fa-fw fa-first-order',
            name: 'vehicle-booking.menu',
            order: 103,
        })
    })
    .config(function ($stateProvider) {
        $stateProvider
            .state('vehicleBookingDashboard', {
                parent: 'app',
                url: '/vehicle-booking-dashboard?{page:int}&{size:int}&{sort:string}&{search:string}&type',
                data: {
                    authorities: ['ROLE_VEHICLE_BOOKING'],
                },
                views: {
                    'content@': 'vehicleBookingDashboard'
                }
            })
            .state('vehicleBookingList', {
                parent: 'app',
                url: '/vehicle-booking-list?{page:int}&{size:int}&{sort:string}&{search:string}&{location:int}&{status:string}&{periodStart}&{periodEnd}&{vehicle:int}&{user:id}',
                data: {
                    authorities: ['ROLE_VEHICLE_BOOKING'],
                },
                params: {
                    status: {array: true, value: [], squash: false},
                },
                views: {
                    'content@': 'vehicleBookingList'
                },
                resolve: {
                    filters: $stateParams => angular.copy($stateParams),
                    statistics: (VehicleBooking, $stateParams) => VehicleBooking.tableStatistics(angular.copy($stateParams)).$promise,
                    page: (VehicleBooking, $stateParams) => VehicleBooking.table(angular.copy($stateParams)).$promise
                }
            })
            .state('vehicleBookingAvailability', {
                parent: 'app',
                url: '/vehicle-booking-availability?{page:int}&{size:int}&{sort:string}&{search:string}&{startTime:datetimeiso}&{endTime:datetimeiso}&{location:int}&{vehicle:int}&type&drive&transmission&fuel',
                data: {
                    authorities: ['ROLE_VEHICLE_BOOKING'],
                },
                views: {
                    'content@': 'vehicleBookingAvailability'
                },
                resolve: {
                    filters: $stateParams => angular.copy($stateParams),
                    page: (VehicleBooking, $stateParams) => VehicleBooking.availability(angular.copy($stateParams)).$promise
                }
            })
            .state('vehicleBookingShow', {
                parent: 'app',
                url: '/vehicle-booking/{id}',
                data: {
                    authorities: ['ROLE_VEHICLE_BOOKING'],
                },
                views: {
                    'content@': 'vehicleBookingShow'
                },
                resolve: {
                    item: (VehicleBooking, $stateParams) => VehicleBooking.get({id: $stateParams.id}).$promise
                }
            })
    })
